import { VendiaFormApi } from 'src/components/fields/form'
import MonacoEditorField from 'src/components/fields/monaco-editor.field'
import Icon from 'src/components/icons/icon'

import { getRoleJsonSchema } from '../schema/org-schema'

interface CustomRoleBuilderProps {
  form: VendiaFormApi<any>
}

export const CustomRoleBuilder = ({ form }: CustomRoleBuilderProps) => {
  return (
    <div>
      <MonacoEditorField
        form={form}
        id='customRoleCapabilities'
        name='role.capabilities'
        language='json'
        validators={{
          onChange: ({ value }: any) => {
            try {
              if (typeof value === 'string') {
                JSON.parse(value)
              }
            } catch (e) {
              return 'Invalid JSON'
            }
          },
        }}
        // override default onChange which sets as string because org-role-edit.page.tsx has logic that relies on this
        onChange={(value: any) => {
          if (form.getFieldMeta('role.capabilities')?.errors.length) {
            return
          }
          form.setFieldValue('role.capabilities', JSON.parse(value))
        }}
        minHeight={600}
        options={{
          lineNumbers: 'on' as any,
          padding: { top: 20 },
        }}
        beforeMount={(monaco) => {
          monaco.languages.json.jsonDefaults.setDiagnosticsOptions({
            validate: true,
            schemas: [
              {
                uri: 'http://vendia.com/role.json', // Not a real URL, doesn't matter
                fileMatch: ['*'], // associate with our model
                schema: getRoleJsonSchema(),
              },
            ],
          })
        }}
        theme='vs-dark'
        className='overflow-hidden rounded-lg'
      />
    </div>
  )
}
